import { BehaviorSubject } from 'rxjs';

export function BehaviorSubjectToObservable(init = null) {
  const BS = new BehaviorSubject(init);
  let bs = BS.asObservable();
  return [bs, BS.next];
}
